var React = require('react');

function FilterArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 2L10 10L18 2","strokeWidth":"3"}));
}

FilterArrowInline.defaultProps = {"width":"20","height":"13","viewBox":"0 0 20 13","fill":"none","className":"svg"};

module.exports = FilterArrowInline;

FilterArrowInline.default = FilterArrowInline;
